<template>
<div class="row">

  <div class="col-12" v-for="day in days" :key="day.name">
    <div class="dayselector">
      <div class="dayselector-checkbox">
        <div class="squaredThree">
          <input type="checkbox" value="None" :id="day.name+clinic_id" v-model="day.selected" @click="addDefaultTimetable(day)" />
          <label :for="day.name+clinic_id"></label>
        </div>
      </div>

      <div class="dayselector-detail">
        <span>{{day.name}}</span>
        <div v-if="day.selected">
          <div class="dayselector-detail-item" v-for="(t, index) in day.timetable" :key="index">
            <form class="form-inline">
              <vue-timepicker :minute-interval="30" v-model="t.from_time"></vue-timepicker>
              <span class="">{{$t('message.schedules.to')}}</span>
              <vue-timepicker :minute-interval="30" v-model="t.to_time"></vue-timepicker>
              <span class="text-danger" @click="removeTimetable(day.timetable, index)" v-if="index>0"><i class="fa fa-times" aria-hidden="true"></i></span>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col-12 dayselector-addtime" v-if="day.selected">
            <a @click="addMoreTimetable(day)">
              <i class="fa fa-plus-circle fa-lg fa-fw text-success" aria-hidden="true"></i> 
              <span>{{$t('message.schedules.add_time_slot')}}</span>
            </a>
          </div>
          <div v-if="advance_week_option && day.selected" class="col-12 dayselector-options">
            <a @click="day.showAdvance = !day.showAdvance">
              <i class="fa fa-calendar-times-o fa-lg fa-fw text-success" aria-hidden="true"></i>
              <span>{{(day.showAdvance) ? $t('message.schedules.hide') : $t('message.schedules.show')}} {{$t('message.schedules.options')}}</span>
            </a> 
          </div>
        </div>
        <div v-show="day.selected && day.showAdvance" class="dayselector-advance-group animated fadeIn">
          <div>
            <span>{{$t('message.schedules.week')}}</span>
          </div>
          <div class="dayselector-advance-group-week">
            <div class="squaredThree">
              <input type="checkbox" value="None" :id="`${clinic_id}-${day.name}-week_enable_1`" v-model="day.week_1_enable"/>
              <label :for="`${clinic_id}-${day.name}-week_enable_1`"></label>
            </div>
            <span class="dayselector-advance-group-label">1</span>
            
            <div class="squaredThree">
              <input type="checkbox" value="None" :id="`${clinic_id}-${day.name}-week_enable_2`" v-model="day.week_2_enable"/>
              <label :for="`${clinic_id}-${day.name}-week_enable_2`"></label>
            </div>
            <span class="dayselector-advance-group-label">2</span>

            <div class="squaredThree">
              <input type="checkbox" value="None" :id="`${clinic_id}-${day.name}-week_enable_3`" v-model="day.week_3_enable"/>
              <label :for="`${clinic_id}-${day.name}-week_enable_3`"></label>
            </div>
            <span class="dayselector-advance-group-label">3</span>

            <div class="squaredThree">
              <input type="checkbox" value="None" :id="`${clinic_id}-${day.name}-week_enable_4`" v-model="day.week_4_enable"/>
              <label :for="`${clinic_id}-${day.name}-week_enable_4`"></label>
            </div>
            <span class="dayselector-advance-group-label">4</span>

            <div class="squaredThree">
              <input type="checkbox" value="None" :id="`${clinic_id}-${day.name}-week_enable_5`" v-model="day.week_5_enable"/>
              <label :for="`${clinic_id}-${day.name}-week_enable_5`"></label>
            </div>
            <span class="dayselector-advance-group-label">5</span>

            <div class="squaredThree">
              <input type="checkbox" value="None" :id="`${clinic_id}-${day.name}-week_enable_last`" v-model="day.week_last_enable"/>
              <label :for="`${clinic_id}-${day.name}-week_enable_last`"></label>
            </div>
            <span class="dayselector-advance-group-label">{{$t('message.schedules.last_week')}}</span>
          </div>
        </div>
      </div>

    </div>

    <div class="form-divider"></div>
  </div>

</div>
</template>

<script>
import 'jquery'
import VueTimepicker from 'vue2-timepicker'
export default {
  components: {
    VueTimepicker
  },
  props: {
    schedules: Array,
    clinic_id: Number,
    doctor_id: Number,
    booking_per_slot: Number,
    time_slots: Number,
    advance_week_option: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      days: [
        {
          name: this.$t('message.schedules.monday'),
          week_day: 'mon',
          selected: false,
          timetable: [],
          showAdvance: false,
          week_1_enable: 1,
          week_2_enable: 1,
          week_3_enable: 1,
          week_4_enable: 1,
          week_5_enable: 1,
          week_last_enable: 1
        },
        {
          name: this.$t('message.schedules.tuesday'),
          week_day: 'tue',
          selected: false,
          timetable: [],
          showAdvance: false,
          week_1_enable: 1,
          week_2_enable: 1,
          week_3_enable: 1,
          week_4_enable: 1,
          week_5_enable: 1,
          week_last_enable: 1
        },
        {
          name: this.$t('message.schedules.wednesday'),
          week_day: 'wed',
          selected: false,
          timetable: [],
          showAdvance: false,
          week_1_enable: 1,
          week_2_enable: 1,
          week_3_enable: 1,
          week_4_enable: 1,
          week_5_enable: 1,
          week_last_enable: 1
        },
        {
          name: this.$t('message.schedules.thursday'),
          week_day: 'thu',
          selected: false,
          timetable: [],
          showAdvance: false,
          week_1_enable: 1,
          week_2_enable: 1,
          week_3_enable: 1,
          week_4_enable: 1,
          week_5_enable: 1,
          week_last_enable: 1
        },
        {
          name: this.$t('message.schedules.friday'),
          week_day: 'fri',
          selected: false,
          timetable: [],
          showAdvance: false,
          week_1_enable: 1,
          week_2_enable: 1,
          week_3_enable: 1,
          week_4_enable: 1,
          week_5_enable: 1,
          week_last_enable: 1
        },
        {
          name: this.$t('message.schedules.saturday'),
          week_day: 'sat',
          selected: false,
          timetable: [],
          showAdvance: false,
          week_1_enable: 1,
          week_2_enable: 1,
          week_3_enable: 1,
          week_4_enable: 1,
          week_5_enable: 1,
          week_last_enable: 1
        },
        {
          name: this.$t('message.schedules.sunday'),
          week_day: 'sun',
          selected: false,
          timetable: [],
          showAdvance: false,
          week_1_enable: 1,
          week_2_enable: 1,
          week_3_enable: 1,
          week_4_enable: 1,
          week_5_enable: 1,
          week_last_enable: 1
        }
      ]
    }
  },
  methods: {
    addDefaultTimetable (day) {
      if (day.selected) {
        if (day.timetable.length === 0) {
          day.timetable.push({
            from_time: {
              HH: '08',
              mm: '00'
            },
            to_time: {
              HH: '17',
              mm: '00'
            }
          })
        }
      } else {
        day.timetable = []
      }
    },
    addMoreTimetable (day) {
      let overHour = 25
      let workHour = 10
      let offsetNextHour = 1
      let offsetNextThreeHour = 4
      var prevTime = day.timetable[day.timetable.length - 1]
      var nextHour = +prevTime.to_time.HH + offsetNextHour // offset
      if (nextHour === overHour) nextHour = 0
      nextHour = nextHour >= workHour ? nextHour + '' : '0' + nextHour

      var endHour = +prevTime.to_time.HH + offsetNextThreeHour // offset next three hour
      if (endHour === overHour) endHour = 0
      endHour = endHour >= workHour ? endHour + '' : '0' + endHour
      day.timetable.push({
        from_time: {
          HH: nextHour,
          mm: '00'
        },
        to_time: {
          HH: endHour,
          mm: '00'
        }
      })
    },
    removeTimetable (timetable, index) {
      timetable.splice(index, 1)
    },
    _tranformSchedule () {
      /* return example object
       * "id": 1382,
       * "doctor_id": 317,
       * "clinic_id": 18,
       * "week_day": "sat",
       * "time_from": "9:00:00",
       * "time_to": "18:00:00",
       * "time_slots": 30,
       * "booking_per_slot": 4
       * */
      var self = this
      var schedule = []
      let defaultSlot = 30
      let defaultBooking = 4
      this.days.forEach(d => {
        if (d.selected) {
          d.timetable.forEach(t => {
            let newSchedule = {
              doctor_id: self.doctor_id,
              clinic_id: self.clinic_id,
              week_day: d.week_day,
              time_from: (t.from_time.HH + ':' + t.from_time.mm),
              time_to: (t.to_time.HH + ':' + t.to_time.mm),
              time_slots: self.time_slots || defaultSlot,
              booking_per_slot: self.booking_per_slot || defaultBooking,
              week_1_enable: d.week_1_enable,
              week_2_enable: d.week_2_enable,
              week_3_enable: d.week_3_enable,
              week_4_enable: d.week_4_enable,
              week_5_enable: d.week_5_enable,
              week_last_enable: d.week_last_enable
            }
            if (t.id) newSchedule.id = t.id
            schedule.push(newSchedule)
          })
        }
      })
      return schedule
    },
    _convertTimeForPicker (t) {
      // t: 08:00:00
      var hms = t.split(':')
      return {
        HH: hms[0],
        mm: hms[1]
      }
    },
    emitScheduleChangedEvent () {
      // when days data changed it will emit below event.
      this.$emit('scheduleChanged', this.clinic_id, this._tranformSchedule())
    }
  },
  watch: {
    days: {
      handler (v, o) {
        this.emitScheduleChangedEvent()
      },
      deep: true
    },
    booking_per_slot: {
      handler (v, o) {
        this.emitScheduleChangedEvent()
      },
      deep: true
    },
    time_slots: {
      handler (v, o) {
        this.emitScheduleChangedEvent()
      },
      deep: true
    }
  },
  created () {
    // tranform data
    var self = this
    this.schedules.forEach(s => {
      // match a day for filling values
      var d = self.days.find(_d => _d.week_day === s.week_day)
      d.showAdvance = s.week_1_enable === 0 || s.week_2_enable === 0 || s.week_3_enable === 0 || s.week_4_enable === 0 || s.week_5_enable === 0 || s.week_last_enable === 0
      d.selected = true
      d.week_1_enable = s.week_1_enable
      d.week_2_enable = s.week_2_enable
      d.week_3_enable = s.week_3_enable
      d.week_4_enable = s.week_4_enable
      d.week_5_enable = s.week_5_enable
      d.week_last_enable = s.week_last_enable
      d.timetable.push({
        id: s.id,
        from_time: self._convertTimeForPicker(s.time_from),
        to_time: self._convertTimeForPicker(s.time_to)
      })
    })
  }
}
</script>

<style lang="less">
.form-divider{
  height: 1px;
  border: 1px dashed #eee;
  margin: 10px 0;
  width: 100%;
}
.dayselector {
	display: flex;

	.dayselector-checkbox {
		width: 50px;
	}

	.dayselector-detail {
		.dayselector-detail-item {
          margin: 10px 0px;
                span {
                    margin: 0 10px;
                }
          select {
            width: 100px;
          }
		}
		.dayselector-addtime{
			margin: 10px 0px 0px;
            cursor: pointer;
		}
	}
}

.dayselector-options {
  margin: 10px 0px;
  cursor: pointer;
}

.dayselector-advance-group {
  display: flex;
  margin-left: 1.7rem;
}

.dayselector-advance-group-week {
  display: flex;
}

.dayselector-advance-group-label {
  margin-left: 20px;
  margin-right: 5px;
}

</style>



// WEBPACK FOOTER //
// WorkingSchedule.vue?39d48622